import { ModelModel } from './model.model';
import { ImageModel } from './image.model';
import { ImageUploadImageSetModel } from '../../image-admin/image-models/image-upload-image-set.model';
export class ProductModel {
  id: string;
  title: string;
  type: string;
  description: string;
  images: ImageUploadImageSetModel[];
  overview: string;
  benefitsFeatures: string;
  line: string[];
  publishon: string;
  unpublishon: string;
  classes: string[];
  models: ModelModel[];
  relatedProducts: ProductModel[];
  resDescription: string;
  resBenefitsFeatures: string;
  resOverview: string;
  iscommercial: boolean;
  category: string;
  family: string;
  constructor(data?) {
    const productData = data || {};
    this.id = productData.id; // productData.ID;
    this.description = productData.description; // productData.Description;
    this.title = productData.name; // productData.Title;
    this.type = productData.family ? productData.family : productData.label; // productData.Type;
    this.line = productData.line ? productData.line : [];
    this.overview = productData.overview;
    this.benefitsFeatures = productData.benefitsFeatures;
    this.classes = productData.class ? productData.class : [];
    this.publishon = productData.publishOn;
    this.unpublishon = productData.unpublishOn;
    this.resDescription = productData.resDescription;
    this.resOverview = productData.resOverview;
    this.resBenefitsFeatures = productData.resBenefitsFeatures;
    this.images = productData.imageSets ? productData.imageSets.map(item => new ImageUploadImageSetModel(item)) : [];
    this.models = productData.models ? productData.models.map(item => new ModelModel(item)) : [];
    this.relatedProducts = productData.relatedProductTypes ? productData.relatedProductTypes.map(item => new ProductModel(item)) : [];
    this.category = productData.category;
    this.family = productData.family;
  }

  public shouldDisplay(iscommercial: string, productClass: string): boolean {
    let isInLine = false;
    if (iscommercial === 'true') {
      for (const line of this.line ) {
        if (line === 'Commercial') {
          isInLine = true;
          break;
        }
      }
      if (! isInLine) {
        return false;
      }
      if (! productClass) {
        // If class not selected show all models
        return true;
      }
      switch (productClass) {
        case 'Outdoor Units':
          for (const item of this.classes) {
            if (item === 'Multi V' && this.category === 'Outdoor Units') {
              return true;
            }
          }
          return false;

        case 'Indoor Units':
          for (const item of this.classes) {
            if (item === 'Multi V' && this.category === 'Indoor Units') {
              return true;
            }
          }
          return false;

        case 'Controls':
        case 'Accessories':
        case 'Air Technologies':
        case 'Chillers':
          for (const item of this.classes) {
            if (item === 'Multi V' && this.category === productClass) {
              return true;
            }
          }
          return false;

        default:
          return false;
      }
    } else {
      for (const line of this.line ) {
        if (line === 'Residential/Light Commercial') {
          isInLine = true;
          break;
        }
      }
      if (! isInLine) {
        return false;
      }

      if (! productClass) {
        // If class not selected show all models
        return true;
      }

      switch (productClass) {
        case 'Single Zone':
          for (const item of this.classes) {
            if (item === 'Single Zone' && this.category === 'Indoor Units') {
              return true;
            }
          }
          return false;

        case 'Multi Zone Indoor':
          for (const item of this.classes) {
            if (item === 'Multi Zone' && this.category === 'Indoor Units') {
              return true;
            }
          }
          return false;

        case 'Multi Zone Outdoor':
          for (const item of this.classes) {
            if (item === 'Multi Zone' && this.category === 'Outdoor Units') {
              return true;
            }
          }
          return false;

        case 'Controls':
        case 'Accessories':
        case 'Water Heating':
        case 'Air Technologies':
          for (const item of this.classes) {
            if ( (item === 'Multi Zone' || item === 'Single Zone') && this.category === productClass) {
              return true;
            }
          }
          return false;

        case 'PTAC':
          for (const item of this.classes) {
            if ( (item === 'PTAC') || this.family === 'PTAC Units' || this.family === 'PTAC Accessories') {
              return true;
            }
          }
          return false;

        default :
          return false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/product.model.ts